import { services } from 'common';
const { Application } = services;
import { IMarketHomePageData } from '../interface/pageData';

class AppService extends Application<IMarketHomePageData> {}
const templateData = Application.getTemplateData();
const data = templateData.data;
const config = templateData.config;
const pageData: IMarketHomePageData = {
    Lang: config.lang,
    SYSTEM: config.system,
    siteHost: config.site_host,
    userInfo: data.user_info,
    contextInfo: data.context_info,
};

// tslint:disable-next-line:no-console
console.log(pageData);

const appService = new AppService(pageData);
const getAppData = appService.getData;
export default appService;
export { getAppData };
